import InputCus from "../../Component/InputCus/Text/InputCus";
import { useEffect, useState } from "react";
import {
  CompanyFilterCompanyStore,
  CompanyCreateCompanyStore,
  CompanyUpdateCompanyStore,
  CompetitorFilterCompetitor,
} from "../../Api/Services";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import Select from "../../Component/InputCus/Select/Select";

function StoreAE() {
  const [isLoading, setLoading] = useState(true);
  const [form, setForm] = useState({});
  const [competitor, setCompetitor] = useState([]);

  const navigate = useNavigate();

  let { id, extra } = useParams();

  const start = async () => {
    try {
      const CompetitorFilterCompetitorData = await CompetitorFilterCompetitor(
        {}
      );
      if (
        CompetitorFilterCompetitorData.status &&
        CompetitorFilterCompetitorData.status === 200
      ) {
        setCompetitor(CompetitorFilterCompetitorData.data.data.data);
      }

      if (extra) {
        const CompanyFilterCompanyStoreData = await CompanyFilterCompanyStore({
          id: extra,
          CompanyId: id,
        });
        if (
          CompanyFilterCompanyStoreData.status &&
          CompanyFilterCompanyStoreData.status === 200
        ) {
          setForm(CompanyFilterCompanyStoreData.data.data.data[0]);
        }
      }
    } catch (error) {
      console.error("Error during login:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    start();
  }, []);

  const AddUpdate = async () => {
    let validation = true;
    if (form.name === "") {
      toast.error("نام را وارد نمایید ");
      validation = false;
    }
    if (form.code === "") {
      toast.error("کد را وارد نمایید ");
      validation = false;
    }
    if (form.percentage === "") {
      toast.error("درصد را وارد نمایید ");
      validation = false;
    }
    if (validation) {
      setLoading(true);
      try {
        if (extra) {
          const CompanyUpdateCompanyStoreData = await CompanyUpdateCompanyStore(
            form
          );
          if (
            CompanyUpdateCompanyStoreData.status &&
            CompanyUpdateCompanyStoreData.status === 200
          ) {
            toast.success("بروزرسانی با موفقیت انجام شد");
            navigate("/Panel/Companys/Store/" + id);
          }
        } else {
          const CompanyCreateCompanyStoreData = await CompanyCreateCompanyStore(
            {
              ...form,
              companyId: id,
            }
          );
          if (
            CompanyCreateCompanyStoreData.status &&
            CompanyCreateCompanyStoreData.status === 200
          ) {
            toast.success("افزودن  با موفقیت انجام شد");
            navigate("/Panel/Companys/Store/" + id);
          }
        }
      } catch (error) {
        console.error("Error during login:", error);
      } finally {
        setLoading(false);
      }
    }
  };

  const handleChangeSearch = (e) => {
    const newForm = { ...form };
    newForm[e.target.id] = e.target.value;
    setForm(newForm);
  };

  return (
    <div>
      {isLoading && (
        <div className="d-flex justify-content-center align-items-center">
          <div className="lds-facebook">
            <div />
            <div />
            <div />
          </div>
        </div>
      )}
      <div className={isLoading ? "startLoading" : "stateLoading"}>
        <div className="w-100 d-flex justify-content-between align-items-start p-5">
          <div className="d-flex justify-content-start align-items-center flex-column element w-100 p-5">
            <div className="d-flex justify-content-start align-items-center w-100">
              <InputCus
                type="text"
                name="name"
                id="name"
                className="m-2"
                text="نام"
                value={form.name || ""}
                onChange={handleChangeSearch}
              />
              <InputCus
                type="text"
                name="code"
                className="m-2"
                id="code"
                text="کد"
                value={form.code || ""}
                onChange={handleChangeSearch}
              />
              <InputCus
                type="text"
                name="percentage"
                id="percentage"
                className="m-2"
                text="درصد"
                value={form.percentage || ""}
                onChange={handleChangeSearch}
              />
              <Select
                className="m-2"
                name="isSite"
                id="isSite"
                text="اتصال به سایت"
                value={form.isSite || ""}
                onChange={handleChangeSearch}
                option={[
                  { value: true, title: "متصل" },
                  { value: false, title: "عدم اتصال" },
                ]}
              />
              <Select
                className="m-2"
                name="isList"
                id="isList"
                text="لیست قیمت اتوماتیک"
                value={form.isList || ""}
                onChange={handleChangeSearch}
                option={[
                  { value: true, title: "متصل" },
                  { value: false, title: "عدم اتصال" },
                ]}
              />
              <Select
                className="m-2"
                name="competitorId"
                id="competitorId"
                text="نام مرجع"
                value={form.competitorId || ""}
                onChange={handleChangeSearch}
                option={competitor.map((item) => ({
                  value: item.id,
                  title: item.competitorCategoryName + "-" + item.name,
                }))}
              />
              <InputCus
                type="text"
                name="urlSite"
                id="urlSite"
                className="m-2"
                text="ادرس سایت"
                value={form.urlSite || ""}
                onChange={handleChangeSearch}
              />
            </div>
            <div className="d-flex justify-content-start align-items-center w-100 m-5">
              <button onClick={AddUpdate} className="butAU">
                {extra ? "ویرایش" : "افزودن"}{" "}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default StoreAE;
